import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { Slideshow, Button, TabsResponsive, Heading } from "components"
import { A } from "AtomicComponents"

const Large = Radium((props = {}) => {
  const {
    activeService,
    fullDetailsURL,
    factoryCode,
    activeServiceCodeIndex,
    services,
    onServiceSelect
  } = props

  return (
    <div style={largeStyles.wrapper}>
      {!factoryCode && (
        <div style={{ width: "100%", margin: "auto", paddingBottom: "3em", overflow: "hidden" }}>
          <TabsResponsive
            active={activeServiceCodeIndex}
            animatedLine
            options={services}
            onChange={(e) => {
              onServiceSelect(services.findIndex(s => s.code === e.code))
            }} />
        </div>
      )}
      <div
        style={{
          width: "100%",
          margin: "auto",
          boxSizing: "border-box",
          padding: "0 1em 1em"
        }}>
        <div style={{ position: "relative", transition: "height 1s ease-in-out" }}>
          {services.map(s => (
            <div
              key={s.code}
              style={{
                textAlign: "left",
                columnCount: 3,
                MozColumnCount: 3,
                margin: "auto",
                paddingTop: "4em",
                paddingBottom: "3em",
                display: s.item.factoryCodeEntity.code === activeService.code ? "block" : "none"
              }}>
              {s.item.operationActions.map(category => (
                <div style={{ display: "block", paddingBottom: "1.5em" }} key={category.name}>
                  <h4 style={largeStyles.scheduledMaintenanceItem}>{category.name}</h4>
                  {category.operations.map(o =>
                    (o.name === "M-MDS M-MDS" ? null : (
                      <span key={o.subOpCode} style={largeStyles.scheduledMaintenanceItem}>
                        {o.name}
                      </span>
                    )))}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div
          style={[
            largeStyles.basicsLastLine,
            {
              fontWeight: 600,
              letterSpacing: 1.8,
              fontSize: "81%",
              marginLeft: "0.4em"
            }
          ]}>
          <A href={fullDetailsURL}>
            view service details ›{" "}
          </A>
        </div>
      </div>
    </div>
  )
})

const largeStyles = {
  wrapper: {
    width: "100%"
  },

  basicsLastLine: {
    width: "100%",
    textTransform: "uppercase",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },

  scheduledMaintenanceItem: {
    display: "block",
    padding: "0.3em",
    fontSize: "16px",
    marginTop: "0",
    marginBottom: "5px"
  }
}

const Compact = Radium((props = {}) => {
  const {
    fullDetailsURL, factoryCode, activeServiceCodeIndex, services, onServiceSelect
  } = props

  return (
    <div style={compactStyles.wrapper}>
      {!factoryCode && (
        <div>
          <div
            style={{
              color: "#b8b6b8",
              fontStyle: "italic",
              textAlign: "center",
              padding: "1em"
            }}>
            Swipe to see your first five services
          </div>
          <Slideshow
            showBullets
            activate={activeServiceCodeIndex}
            bulletsBelow
            handleChange={(index) => {
              if (Math.floor(index) !== parseFloat(activeServiceCodeIndex)) {
                onServiceSelect(Math.floor(index))
              }
            }}>
            {services.map((s, index) => (
              <div key={index} style={{ paddingBottom: "1em" }}>
                <div
                  style={{
                    border: "solid 1px #b8b6b8",
                    marginLeft: "1em",
                    marginRight: "1em",
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: "2em",
                    paddingBottom: "2em",
                    alignItems: "center"
                  }}>
                  <Heading value={s.shortName} />
                  <div style={compactStyles.basePriceMobile}>{s.price}</div>
                  <div style={{ fontStyle: "italic" }}>{s.extraLabel}</div>
                  <div style={{ pointerEvents: "auto" }}>
                    <Button
                      type="a"
                      styleName="black"
                      label="Service details"
                      href={fullDetailsURL} />
                  </div>
                </div>
              </div>
            ))}
          </Slideshow>
        </div>
      )}
      {factoryCode && (
        <div
          style={{
            boxSizing: "border-box",
            paddingTop: "2em",
            paddingBottom: "2em"
          }}>
          <Button
            styleName="blackOutlined"
            label="View service details"
            href={fullDetailsURL}
            fullWidth
            inline />
        </div>
      )}
    </div>
  )
})

const compactStyles = {
  wrapper: {
    display: "block",
    textAlign: "center",
    width: "100%",
    boxSizing: "border-box"
  },
  basePriceMobile: {
    fontWeight: 600,
    fontSize: "2em",
    margin: "1em"
  }
}

export default function ServiceMainPanel(props = {}) {
  return props.compact ? <Compact {...props} /> : <Large {...props} />
}

ServiceMainPanel.propTypes = Large.propTypes = Compact.propTypes = {
  services: PropTypes.array,
  activeService: PropTypes.object,
  fullDetailsURL: PropTypes.string,
  factoryCode: PropTypes.string,
  activeServiceCodeIndex: PropTypes.number,
  compact: PropTypes.bool,
  onServiceSelect: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/containers/service-main-panel/index.jsx